<div class="exploring-evolution-criteria-card">
  <div class="evaluation-card-header">
    <span><i class="fa-solid fa-lightbulb-on"></i></span>
    <p>Exploring Evaluation Criteria</p>
  </div>
  <div class="evaluation-subheader">
    Webbtree AI matches candidates to your needs and shows why they’re the right fit.
  </div>
  <div class="evaluation-middle-content">
    <p>Tips to Use</p>
    <ol>
      <li>Instead of <span>“Senior Dev,”</span> write <span>“3+ years backend development.”</span></li>
      <li>Prioritize criteria by impact and weight.</li>
      <li>Avoid generic criteria - apply reasoning for smart. relevant criteria</li>
    </ol>
  </div>
  <div class="evaluation-footer">
    <h3>Example Criteria</h3>
    <div class="example-list">
      <p class="warnign-icon"> <i class="fa-regular fa-warning"></i> 3+ years backend development</p>
      <p class="green-check">  <i class="fa-regular fa-circle-check"></i> Led scalable backend projects for 3+ years</p>
    </div>
    <div class="example-list">
      <p class="warnign-icon"> <i class="fa-regular fa-warning"></i> Proficient in Python</p>
      <p class="green-check">  <i class="fa-regular fa-circle-check"></i> Built production-grade Python applications</p>
    </div>
    <div class="example-list">
      <p class="warnign-icon"> <i class="fa-regular fa-warning"></i> Bachelor’s in CS (or related)</p>
      <p class="green-check">  <i class="fa-regular fa-circle-check"></i>  BS in CS with algorithms/data structures coursework</p>
    </div>
      <div class="example-list">
      <p class="warnign-icon"> <i class="fa-regular fa-warning"></i> Experience with REST APIs</p>
      <p class="green-check">  <i class="fa-regular fa-circle-check"></i> Designed RESTful APIs handling 10K+ requests/month</p>
    </div>
     <div class="example-list">
      <p class="warnign-icon"> <i class="fa-regular fa-warning"></i> Familiar with SQL database</p>
      <p class="green-check">  <i class="fa-regular fa-circle-check"></i> Optimized SQL databases for 1M+ records</p>
    </div>
  </div>
</div>
